import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Accordion } from "react-bootstrap-accordion";
import { connect } from "react-redux";
import {
  setAppTokenAsked,
  setAppTokenRetrieved,
  setFormation,
  togglePreloader,
} from "../../store/actions";
import { Rate } from "antd";
import { mkSchool } from "../../assets/images";
import { Link } from "react-router-dom";
import { slugify } from "../../helpers/utilities";
import Carousels from "../../components/common/Carousels";
import Maper from "../../components/common/Maper";
import equal from "deep-equal";
import { getFormation } from "../../services/formationService";
import { addComment } from "../../services/commentService";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import { useParams, useLocation } from "react-router-dom";
import Frame from "../../components/common/UniBanner";

import face from "../../assets/images/university/face.png";
import banner from "../../assets/images/formation-banner.png";

import tick from "../../assets/images/university/tick.png";

import share from "../../assets/images/university/share.png";
import like from "../../assets/images/university/like.png";

import date from "../../assets/images/university/date.png";
import CommonIcon from "../../components/common/CommonIcon";
import person from "../../assets/images/university/person.png";
import lang from "../../assets/images/university/lang.png";
import twitter from "../../assets/images/university/twitter.png";
import youtube from "../../assets/images/university/youtube.png";
import insta from "../../assets/images/university/insta.png";
import whatsapp from "../../assets/images/university/whats.png";
import togo from "../../assets/images/university/togo.png";
import degreeExample from "../../assets/images/university/degreeExample.png";
import articleexp from "../../assets/images/university/articleexp.png";
import Banner from "../../components/common/Banner";
import SocialShare from "../../components/common/SocialShare";
import { SCHOOL } from "../../helpers/dummies";

function FormationPage({ note }) {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const shareLink = `https://dev.aceorientation.com/formations/${slugify(
    note
  )}`;

  const handleShareModalOpen = () => {
    setIsShareModalOpen(true);
  };

  const handleShareModalClose = () => {
    setIsShareModalOpen(false);
  };
  const noteValue = parseFloat(note);
  const location = useLocation();
  const { formationCode } = location.state || null;

  const [filteredResults, setFilteredResults] = useState({
    coordinates: { lat: "6.4727929", lng: "2.6089934" },
  });

  const [zIndex, setZIndex] = useState("-1");
  const [formation, setFormation] = useState(null);
  useEffect(() => {
    console.log("formationCode", formationCode);
    getFormation(formationCode).then((res) => {
      console.log("formation", res);
      if (res) {
        setFormation(res);
      } else {
        setFormation(null);
      }
    });
  }, []);

  const getOtherFormations = (id) => {
    getFormation(id).then((res) => {
      console.log("getOtherFormations", res);
      if (res) {
        setFormation(res);
      } else {
        setFormation(null);
      }
    });
  }

  return (
    //  <div id="" className={`${isPreloader ? "d-none extraBody" : "d-block extraBody"}`}>
    <>
      {/* Breadcrumbs */}
      {formation ? (
        <>
          <div className="container p-16">
            {/* <Breadcrumbs
              extratitle="Côte d’lvoire"
              subtitle="Établissements"
              currentTile="Académie Régionale des Sciences et Techniques"
            /> */}
            <div className="flex justify-between mb-3 mt-2">
              <Breadcrumbs
                extratitle={formation?.country?.name}
                extratitleLink="/"
                subtitle={formation?.school?.name}
                subtitleLink="/"
                extrasubtitle="AGROALIMENTAIRE"
                extrasubtitleLink="/"
                currentTile={formation?.name}
              />
              <CommonIcon />
            </div>
            <section className="home-slider">
              <div className="row">
                <div className="col-lg-12"></div>
              </div>

              <Carousels
                centerMode
                infiniteLooped
                items={SCHOOL.sliders}
                carouselsClasses="banner-carousel"
                itemKey="school_carousel_item"
                withArrows={false}
                withIndicators={false}
                autoPlayed={true}
              />
            </section>

            {/* second section*/}
            <div className="article-left academie-banner">
              <section className="academie-banner academie-information">
                <div className="academie-banner-section-div">
                  <div className="academie-banner-main-div">
                    <div className="academie-content mx-w-100">
                      <div className="academie-content-left">
                        <div className="sub-title">
                          <p>Agroalimentaire</p>
                        </div>
                        <div className="top-block">
                          <div className="title">
                            <h2>{formation.name}</h2>
                          </div>
                          <div className="academie-content-right">
                            <div className="opportunit-icon-div">
                              <div className="opportunit-icon-div-top">
                                <span>Partager</span>
                                <button
                                  type="button"
                                  onClick={handleShareModalOpen}
                                >
                                  <img src={share} alt="share icon" />
                                </button>

                                <SocialShare
                                  opened={isShareModalOpen}
                                  onClosed={handleShareModalClose}
                                  shareLink={shareLink}
                                />
                              </div>

                              <div className="opportunit-icon-div-top">
                                <span>Suivre</span>
                                <a href="">
                                  <img src={like} alt="like Icon" />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="flag-div">
                          <div className="top-title">
                            <span>
                              <img src={tick} alt="tick Icon" />
                              Reconnu par l’État
                            </span>
                            <div>
                              <Rate
                                defaultValue={noteValue}
                                allowClear={false}
                                allowHalf
                              />
                            </div>

                            <a href="#">voir les avis</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="information information-bg-color">
                    <div className="row">
                      <div className="col-lg-3">
                        <div className="information-box infor-clander">
                          <img src={date} alt="date Icon" />
                          <div className="information-content">
                            <p>April 20, 2024</p>
                            <span>Date de la prochaine rentrée</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="information-box infor-clander">
                          <img src={date} alt="date Icon" />
                          <div className="information-content">
                            <p>April 20, 2024</p>
                            <span>Date de la prochaine rentrée</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="information-box infor-clander">
                          <img src={person} alt="person Icon" />
                          <div className="information-content">
                            <p>In person</p>
                            <span>Formats d'apprentissage</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="information-box infor-clander">
                          <img src={lang} alt="lang Icon" />
                          <div className="information-content">
                            <p>French and English</p>
                            <span>Langue d'enseignement</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="information-box infor-clander">
                          <img src={date} alt="date Icon" />
                          <div className="information-content">
                            <p>April 20, 2024</p>
                            <span>Rythme de formation</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="information-box infor-clander">
                          <img src={person} alt="" />
                          <div className="information-content">
                            <p>April 20, 2024</p>
                            <span>
                              Date limite de candidature étudiants
                              internationaux
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="information-box infor-clander">
                          <img src={date} alt="" />
                          <div className="information-content">
                            <p>April 20, 2024</p>
                            <span>
                              Date limite de <br />
                              candidature étudiants internationaux
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 infor-clander">
                        <div className="information-box">
                          <img src={date} alt="" />
                          <div className="information-content">
                            <p>April 20, 2024</p>
                            <span>
                              Estimation du cout en CFA et convertisseurs
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* third section */}

              <section className="article-section">
                <>
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="article-left academie-banner">
                        <div className="academie-banner-section-div">
                          <div className="academie-content">
                            <div className="academie-content-left">
                              <div className="academie-logo">
                                <img src={degreeExample} alt="" />
                              </div>
                              <div className="top-block">
                                <div className="title">
                                  <h5>{formation.school.name}</h5>
                                </div>
                              </div>
                              <div>
                                <Rate
                                  defaultValue={noteValue}
                                  allowClear={false}
                                  allowHalf
                                />
                              </div>

                              <div className="flag-div">
                                <div className="top-title">
                                  <p>
                                    Bomaby .{" "}
                                    <span>
                                      Togo
                                      <a href="">
                                        <img src={togo} alt="" />
                                      </a>
                                    </span>
                                  </p>
                                </div>
                                <div>
                                  <img src={tick} alt="" />
                                  Reconnu par l’État
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="information">
                            <div className="academie-content-bottom-icon">
                              <a
                                href={formation.school.facebookLink}
                                target="_blank"
                              >
                                <img src={face} alt="Face" />
                              </a>
                              <a
                                href={formation.school.instagramLink}
                                target="_blank"
                              >
                                <img src={insta} alt="Face" />
                              </a>
                              <a
                                href={formation.school.whatsappLink}
                                target="_blank"
                              >
                                <img src={whatsapp} alt="Face" />
                              </a>
                              <a
                                href={formation.school.twitterLink}
                                target="_blank"
                              >
                                <img src={twitter} alt="Face" />
                              </a>
                              <a
                                href={formation.school.youtubeLink}
                                target="_blank"
                              >
                                <img src={youtube} alt="Face" />
                              </a>
                            </div>
                            <div className="academie-content-bottom-btn">
                              {/* <a href="#" className="btn">
                                Profil de l’école
                              </a> */}
                              <Link
                                to={{
                                  pathname: `/etablissements/${slugify(
                                    formation.school.name
                                  )}`,
                                  state: {
                                    code: formation.school.publicId,
                                    isPublic: formation.school.isPublic,
                                    name: formation.school.name,
                                  },
                                }}
                                className="btn"
                              >
                                Profil de l’école
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className="adress">
                          <div className="adress-content">
                            <h6>Adresse</h6>
                            <p>{formation.school.address}</p>
                          </div>
                          <div>
                            <Maper
                              withPopup
                              icon={mkSchool}
                              items={filteredResults}
                              redirectLink="/schools"
                              zIndex={zIndex}
                              // size="350"
                              className="school-mapper"
                            />
                          </div>
                        </div>
                        <div className="related-article">
                          <div className="related-article-heading">
                            <h5>Related Articles</h5>
                          </div>
                          <div className="related-article-div">
                            <div className="related-article-img">
                              <img src={articleexp} alt="" />
                            </div>
                            <p>Lorem ipsum dolor sit ame</p>
                          </div>
                          <div className="related-article-div">
                            <div className="related-article-img">
                              <img src={articleexp} alt="" />
                            </div>
                            <p>Lorem ipsum dolor sit ame</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <div className="article-right">
                        <div className="article-video">
                          <img src={banner} alt="" />
                        </div>
                        <div className="article-accordion">
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="accordion" id="accordionExample">
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="headingOne"
                                  >
                                    <button
                                      className="accordion-button"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseOne"
                                      aria-expanded="true"
                                      aria-controls="collapseOne"
                                    >
                                      Description du programme
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseOne"
                                    className="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      Lorem ipsum dolor sit amet, consectetur
                                      adipiscing elit.
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="headingTwo"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseTwo"
                                      aria-expanded="false"
                                      aria-controls="collapseTwo"
                                    >
                                      Conditions d’admission
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseTwo"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingTwo"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      Quisque sapien augue, ornare id leo a,
                                      tristique elementum justo.
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="headingThree"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseThree"
                                      aria-expanded="false"
                                      aria-controls="collapseThree"
                                    >
                                      Inscription et documents requi
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseThree"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingThree"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      Praesent nec ipsum scelerisque dui
                                      condimentum pellentesque eu at lectus.
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="headingFour"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseFour"
                                      aria-expanded="false"
                                      aria-controls="collapseFour"
                                    >
                                      Vie étudiante et logemen
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseFour"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingFour"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      Praesent nec ipsum scelerisque dui
                                      condimentum pellentesque eu at lectus.
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="headingFive"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseFive"
                                      aria-expanded="false"
                                      aria-controls="collapseFive"
                                    >
                                      Option de poursuite d’études à
                                      l’international
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseFive"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingFive"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      Praesent nec ipsum scelerisque dui
                                      condimentum pellentesque eu at lectus.
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="headingSix"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseSix"
                                      aria-expanded="false"
                                      aria-controls="collapseSix"
                                    >
                                      Métiers envisageables - top 3 métiers
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseSix"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingSix"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      Praesent nec ipsum scelerisque dui
                                      condimentum pellentesque eu at lectus.
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="headingSeven"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseSeven"
                                      aria-expanded="false"
                                      aria-controls="collapseSeven"
                                    >
                                      Bourse(s) et financement des études
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseSeven"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingSeven"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      Praesent nec ipsum scelerisque dui
                                      condimentum pellentesque eu at lectus.
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="headingEight"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseEight"
                                      aria-expanded="false"
                                      aria-controls="collapseEight"
                                    >
                                      Visa et immigration
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseEight"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingEight"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      Praesent nec ipsum scelerisque dui
                                      condimentum pellentesque eu at lectus.
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="headingNine"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseNine"
                                      aria-expanded="false"
                                      aria-controls="collapseNine"
                                    >
                                      Contacter l'établissemen
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseNine"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingNine"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      Praesent nec ipsum scelerisque dui
                                      condimentum pellentesque eu at lectus.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </section>
            </div>

            {/* <div className="divider"> </div> */}
            {/*  fourth section  */}

            <div
              style={{
                backgroundColor: "#F2F2F280",
                marginTop: "15px",
                marginBottom: "15px",
              }}
            >
              This content was last updated on Thursday 16 June 2023. Every
              effort has been made to ensure that this information is accurate,
              but changes are likely to occur given the interval between the
              date of publishing an course start date. It is therefore very
              important to check this website for any updates before you apply.
            </div>

            <section className="errow-div">
              <div className="Commentaires-section-div">
                <div className="Commentaires-bottom-content">
                  <h6>Que pensez-vous de l'université?</h6>
                  <a href="#" className="btn">
                    Laisser un commentaire
                  </a>
                </div>
              </div>
            </section>

            {/* <div className="divider"> </div> */}

            {/* fifth section */}
            {/* <div className="sixthSectionContainer">
              <div className="commentComponentBottomBarContainer">
                <div className="commentComponentBottomBarContainerInner">
                  <div className="commentComponentBottomBarText">
                    Que pensez-vous de l'université?
                  </div>
                  <div className="commentComponentBottomBarButton">
                    <div className="commentComponentBottomBarButtonText">
                      Laisser un commentaire
                    </div>
                    <div className="commentComponentBottomBarButtonTextIcon"></div>
                  </div>
                </div>
              </div>
            </div> */}

            {/* <div className="divider"> </div> */}

            <div className="labelLast">
              D’autres établissements qui pourraient vous intéresser
            </div>

            <div className="tab-content" id="ex2-content">
              <div className="tab-box-top">
                <div className="row">
                  {formation && formation.formationsSuggest ? (
                    formation.formationsSuggest?.map((formation, index) => {
                      if (index < 3){
                        return (
                          <div
                            key={index} // Make sure to provide a unique key for each mapped element
                            className="tab-pane col-lg-4 fade show active"
                            id={`ex3-tabs-${index + 1}`}
                            role="tabpanel"
                            aria-labelledby={`ex3-tab-${index + 1}`}
                          >
                            <div className="tab-box-content">
                              <div className="tab-box-content-div">
                                <div className="tab-box-top">
                                  <div className="tab-box-left">
                                    <p>bts</p>
                                  </div>
                                  <div className="tab-box-right">
                                    <ul>
                                      <li>
                                        <a href="#">
                                          <img src={share} alt="" />
                                        </a>
                                      </li>
                                      <li>
                                        <a href="#">
                                          <img src={like} alt="" />
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <h6>{formation.name}</h6>
                                <ul className="start-img-div">
                                  <Rate
                                    defaultValue={
                                      formation.noteValue
                                        ? parseFloat(formation.noteValue)
                                        : parseFloat(0)
                                    }
                                    allowClear={false}
                                    allowHalf
                                  />
                                </ul>
                                <p>Licence pro. en Génie Civil</p>
                                <span>
                                  <img src={tick} alt="" />
                                  Reconnu par l’État
                                </span>
                              </div>
                              <div className="tab-box-bottom">
                                <ul>
                                  <li>
                                    <a href="#">
                                      <img
                                        src="./assest/images/lock.svg"
                                        alt=""
                                        className="lock-img"
                                      />
                                      10 avril 2021
                                    </a>
                                  </li>
                                  <li>
                                    <Link
                                      to={{
                                        pathname: `/formations/${slugify(
                                          formation.name
                                        )}`,
                                        state: {
                                          formationCode: formation.publicId,
                                          formationName: formation.name,
                                        },
                                      }}
                                      onClick={() => getOtherFormations(formation.publicId)}
                                    >
                                      <div className="formationBottomSecondFieldText">
                                        Voir plus{" "}
                                        <i className="bx bx-right-arrow-alt"></i>
                                      </div>
                                    </Link>
                                    {/* <a href="#">
                                      Voir plus
                                      <img
                                        src="./assest/images/errow.svg"
                                        alt=""
                                        className="errow-img"
                                      />
                                    </a> */}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        )}
                    })
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}

      {/* seventh section */}
    </>
  );
}

FormationPage.propTypes = {
  formation: PropTypes.object,
  onSetFormation: PropTypes.func,
  isPreloader: PropTypes.bool,
  tokenFailed: PropTypes.bool,
  tokenRetrieved: PropTypes.bool,
  onAppTokenAsked: PropTypes.func,
  onAppTokenRetrieved: PropTypes.func,
  onPreloaderToggled: PropTypes.func,
};
const mapStateToProps = (state) => ({
  formation: state.formation,
  tokenRetrieved: state.tokenRetrieved,
  tokenFailed: state.tokenFailed,
  isPreloader: state.isPreloader,
});
const mapDispatchToProps = (dispatch) => ({
  onSetFormation: (data) => dispatch(setFormation(data)),
  onAppTokenAsked: (data) => dispatch(setAppTokenAsked(data)),
  onAppTokenRetrieved: (data) => dispatch(setAppTokenRetrieved(data)),
  onPreloaderToggled: (preload, message) =>
    dispatch(togglePreloader(preload, message)),
});
export default connect(mapStateToProps, mapDispatchToProps)(FormationPage);
